export default __webpack_public_path__ + "static/media/register-bg.b3bc10aa.jpg";